.badge {
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 1.4rem;
    font-family: 'Averta', sans-serif;
}

.success {
    background-color: var(--lime-lighter);
    color: var(--ink);
}
.error {
    background-color: var(--red-lighter);
    color: var(--ink);
}
.warning {
    background-color: var(--orange-lighter);
    color: var(--ink);
}
.info {
    background-color: var(--blue-lighter);
    color: var(--ink);
}
.reverse-success {
    background-color: var(--lime);
    color: var(--white);
}
.reverse-error {
    background-color: var(--red);
    color: var(--white);
}
.reverse-warning {
    background-color: var(--orange);
    color: var(--white);
}
.reverse-info {
    background-color: var(--blue);
    color: var(--white);
}
